if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);

          // CrescoSpec
          this.resetQuantityState();
          // end CrescoSpec
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
           //location.reload();
        });
      }

      // CrescoSpec
      resetQuantityState() {
        const product_form = document.querySelector(`product-info .product-form`);
        if(!product_form)return;
        const form_variant_quantities = product_form.querySelectorAll(".product-variant-qty");

        form_variant_quantities.forEach(q=>{
          if(!q.classList.contains("selected_variant")){
            q.value = 0;
          } else {
            q.value = 1;
          }
        });
      };
      // end CrescoSpec

      updateSelectedSwatchValue({ target }) {        
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {

          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');

          const variant_id = target.getAttribute("variant-id");
          const variant_id_atc_form_input = document.querySelector(".product__block--buy_buttons form.custom_atc input[name='id']");

          if(variant_id && variant_id_atc_form_input)variant_id_atc_form_input.setAttribute('value', variant_id);

          if(selectedSwatchValue)selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
